<template>
    <div>
        <div class="row mb-4">
            <!-- Total Hits Card -->
            <div class="col-xl-3 col-md-6 mb-4 mb-xl-0">
                <div class="card h-100 border-0 shadow-sm radius-xl">
                    <div class="card-body d-flex align-items-center justify-content-between p-4">
                        <div>
                            <p class="text-muted text-uppercase fs-12 font-weight-bold mb-2">Total Hits</p>
                            <h2 class="text-primary mb-0 font-weight-bold">{{ totalGlobalHits }}</h2>
                        </div>
                        <div class="icon-shape bg-primary-light text-primary rounded-circle p-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px;">
                            <i class="fas fa-chart-line fa-2x"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Filters Card -->
            <div class="col-xl-9 col-md-6">
                <div class="card h-100 border-0 shadow-sm radius-xl">
                    <div class="card-body p-4 d-flex flex-wrap align-items-end">
                        <div class="form-group mb-0 mr-3 flex-fill">
                            <label class="text-muted fs-12 font-weight-bold mb-2">Dari Tanggal</label>
                            <input type="date" class="form-control" v-model="startDate">
                        </div>
                        <div class="form-group mb-0 mr-3 flex-fill">
                            <label class="text-muted fs-12 font-weight-bold mb-2">Sampai Tanggal</label>
                            <input type="date" class="form-control" v-model="endDate">
                        </div>
                        <div class="form-group mb-0 mt-3 mt-md-0 mr-2">
                            <button class="btn btn-primary d-flex align-items-center justify-content-center px-4" @click="getProviders">
                                <i class="fas fa-filter mr-2"></i> Filter
                            </button>
                        </div>
                        <div class="form-group mb-0 mt-3 mt-md-0">
                            <button class="btn btn-success d-flex align-items-center justify-content-center px-4" @click="testAllProviders" :disabled="isTestingAll">
                                <span v-if="isTestingAll" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                <i v-else class="fas fa-heartbeat mr-2"></i>
                                {{ isTestingAll ? 'Testing...' : 'Test Semua' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table Card -->
        <div class="card border-0 shadow-sm radius-xl">
            <div class="card-body p-0">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead class="bg-light">
                            <tr>
                                <th class="border-top-0 text-muted font-weight-bold pl-4">Nama</th>
                                <th class="border-top-0 text-muted font-weight-bold">Model</th>
                                <th class="border-top-0 text-muted font-weight-bold">Base URL</th>
                                <th class="border-top-0 text-muted font-weight-bold text-center">Priority</th>
                                <th class="border-top-0 text-muted font-weight-bold text-center">Vision</th>
                                <th class="border-top-0 text-muted font-weight-bold text-center">Status</th>
                                <th class="border-top-0 text-muted font-weight-bold">Error Info</th>
                                <th class="border-top-0 text-muted font-weight-bold text-center">Hits</th>
                                <th class="border-top-0 text-muted font-weight-bold text-right pr-4">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                             <tr v-for="provider in providers" :key="provider.id" :class="{'bg-soft-danger': provider.last_error}">
                                <td class="align-middle font-weight-bold pl-4">
                                    <div class="d-flex align-items-center">
                                        <span>{{ provider.name }}</span>
                                        <span v-if="testResults[provider.id] && testResults[provider.id].success" class="badge badge-soft-success ml-2" title="Test OK">
                                            <i class="fas fa-check"></i>
                                        </span>
                                        <span v-else-if="testResults[provider.id] && !testResults[provider.id].success" class="badge badge-soft-danger ml-2" :title="testResults[provider.id].message">
                                            <i class="fas fa-times"></i>
                                        </span>
                                    </div>
                                </td>
                                <td class="align-middle">{{ provider.model }}</td>
                                <td class="align-middle text-truncate" style="max-width: 150px;">{{ provider.base_url }}</td>
                                <td class="align-middle text-center">{{ provider.priority }}</td>
                                <td class="align-middle text-center">
                                    <span v-if="provider.file_support" class="badge badge-soft-primary px-3 py-1 radius-md">Yes</span>
                                    <span v-else class="badge badge-soft-light px-3 py-1 radius-md">No</span>
                                </td>
                                <td class="align-middle text-center">
                                    <span v-if="provider.is_active" class="badge badge-soft-success px-3 py-1 radius-md">Active</span>
                                    <span v-else class="badge badge-soft-danger px-3 py-1 radius-md">Inactive</span>
                                </td>
                                <td class="align-middle">
                                    <div v-if="provider.last_error">
                                        <div class="d-flex align-items-center">
                                            <span class="px-2 mr-2">{{ provider.last_error }}</span>
                                            <button class="btn btn-sm btn-light shadow-none" @click.prevent="openErrorModal(provider)" title="Lihat Detail Error">
                                                <i class="fas fa-eye text-primary"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td class="align-middle font-weight-bold text-center">{{ provider.total_hits || 0 }}</td>
                                <td class="align-middle text-right pr-4">
                                    <div class="d-flex justify-content-end align-items-center">
                                        <button class="btn btn-icon btn-light btn-sm mr-2 shadow-none" v-on:click.prevent="testProvider(provider)" :disabled="testingProviders[provider.id]" title="Test Koneksi">
                                            <span v-if="testingProviders[provider.id]" class="spinner-border spinner-border-sm text-success" role="status" aria-hidden="true"></span>
                                            <i v-else class="fas fa-bolt text-success"></i>
                                        </button>
                                        <button class="btn btn-icon btn-light btn-sm mr-2 shadow-none" v-on:click.prevent="editProvider(provider)" title="Edit">
                                            <i class="fas fa-edit text-primary"></i>
                                        </button>
                                        <button class="btn btn-icon btn-light btn-sm shadow-none" v-on:click.prevent="confirmRemoveProvider(provider.id)" title="Hapus">
                                            <i class="fas fa-trash-alt text-danger"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Delete confirmation modal -->
        <div v-if="showDeleteModal" class="modal fade show" tabindex="-1" role="dialog" style="display:block; background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content border-0 radius-xl shadow-lg">
                    <div class="modal-header border-bottom-0 pb-0">
                        <h5 class="modal-title font-weight-bold">Konfirmasi Hapus</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeDeleteModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-3 pb-4">
                        <p class="text-muted mb-0">Apakah anda yakin ingin menghapus provider ini? Data yang dihapus tidak dapat dikembalikan.</p>
                    </div>
                    <div class="modal-footer border-top-0 pt-0">
                        <button type="button" class="btn btn-light" @click="closeDeleteModal" :disabled="isDeleting">Batal</button>
                        <button type="button" class="btn btn-danger px-4" @click="performDelete()" :disabled="isDeleting">
                            <span v-if="isDeleting" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                            {{ isDeleting ? 'Menghapus...' : 'Ya, Hapus' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Error Detail Modal -->
        <div v-if="showErrorModal" class="modal fade show" tabindex="-1" role="dialog" style="display:block; background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content border-0 radius-xl shadow-lg">
                    <div class="modal-header border-bottom-0 pb-0">
                        <h5 class="modal-title font-weight-bold textual-danger">Detail Error</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeErrorModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-3 pb-4">
                        <div v-if="selectedErrorProvider">
                            <div class="form-group">
                                <label class="text-muted fs-12 font-weight-bold">Tipe Error</label>
                                <div class="p-2 bg-soft-danger rounded text-danger font-weight-bold">
                                    {{ selectedErrorProvider.last_error }}
                                </div>
                            </div>
                            <div class="form-group mb-0">
                                <label class="text-muted fs-12 font-weight-bold">Pesan Error Lengkap</label>
                                <div class="p-3 rounded text-secondary" style="white-space: pre-wrap; word-break: break-all; max-height: 400px; overflow-y: auto; font-family: monospace;">
                                    {{ selectedErrorProvider.error_reason }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-top-0 pt-0">
                        <button type="button" class="btn btn-light" @click="closeErrorModal">Tutup</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Test Result Modal -->
        <div v-if="showTestModal" class="modal fade show" tabindex="-1" role="dialog" style="display:block; background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content border-0 radius-xl shadow-lg">
                    <div class="modal-header border-bottom-0 pb-0">
                        <h5 class="modal-title font-weight-bold" :class="testModalData.success ? 'text-success' : 'text-danger'">
                            <i :class="testModalData.success ? 'fas fa-check-circle' : 'fas fa-exclamation-triangle'" class="mr-2"></i>
                            {{ testModalData.success ? 'Test Berhasil' : 'Test Gagal' }}
                        </h5>
                        <button type="button" class="close" aria-label="Close" @click="closeTestModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-3 pb-4">
                        <div class="form-group mb-3">
                            <label class="text-muted fs-12 font-weight-bold">Provider</label>
                            <div class="font-weight-bold">{{ testModalData.name }}</div>
                        </div>
                        <div class="form-group mb-3">
                            <label class="text-muted fs-12 font-weight-bold">Model</label>
                            <div>{{ testModalData.model }}</div>
                        </div>
                        <div class="form-group mb-0">
                            <label class="text-muted fs-12 font-weight-bold">Hasil</label>
                            <div class="p-3 rounded" :class="testModalData.success ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'" style="white-space: pre-wrap; word-break: break-word; max-height: 300px; overflow-y: auto; font-family: monospace; font-size: 13px;">
                                {{ testModalData.message }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-top-0 pt-0">
                        <button type="button" class="btn btn-light" @click="closeTestModal">Tutup</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            const date = new Date();
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const today = `${year}-${month}-${day}`;
            return {
                providers: [],
                showDeleteModal: false,
                deleteTargetId: null,
                isDeleting: false,
                startDate: today,
                endDate: today,
                showErrorModal: false,
                selectedErrorProvider: null,
                // Test feature state
                testingProviders: {},    // { [providerId]: boolean }
                testResults: {},         // { [providerId]: { success, message } }
                showTestModal: false,
                testModalData: { success: false, name: "", model: "", message: "" },
                isTestingAll: false,
            };
        },
        computed: {
            totalGlobalHits() {
                return this.providers.reduce((sum, provider) => sum + (parseInt(provider.total_hits) || 0), 0);
            }
        },
        mounted() {
            this.getProviders();
            this.$root.$on("refresh_provider_table", this.getProviders);
        },
        beforeDestroy() {
             this.$root.$off("refresh_provider_table", this.getProviders);
        },
        methods: {
            async getProviders() {
                try {
                    let res = await this.$store.dispatch("chatgpt_provider_list", {
                        start_date: this.startDate,
                        end_date: this.endDate
                    });
                    if (res.data.success) {
                        this.providers = res.data.data.providers;
                    }
                } catch (error) {
                    console.error("Failed to fetch providers:", error);
                }
            },
            editProvider(provider) {
                this.$root.$emit("edit_provider", provider);
            },
            confirmRemoveProvider(id) {
                this.deleteTargetId = id;
                this.showDeleteModal = true;
            },
            closeDeleteModal() {
                this.showDeleteModal = false;
                this.deleteTargetId = null;
            },
            openErrorModal(provider) {
                this.selectedErrorProvider = provider;
                this.showErrorModal = true;
            },
            closeErrorModal() {
                this.showErrorModal = false;
                this.selectedErrorProvider = null;
            },
            closeTestModal() {
                this.showTestModal = false;
            },
            async runSingleTest(provider, opts = {}) {
                // Core test logic: fetch detail for api_key, then call test-key.
                // Returns { success, message }.
                const silent = opts.silent || false;
                this.$set(this.testingProviders, provider.id, true);
                try {
                    // 1. Fetch detail to get api_key (not available in list)
                    const detailRes = await this.$store.dispatch("chatgpt_provider_detail", { id: provider.id });
                    const detail = detailRes.data && detailRes.data.data ? detailRes.data.data.provider : null;
                    const apiKey = detail ? detail.api_key : null;
                    if (!apiKey) {
                        const msg = "API Key tidak ditemukan di data provider.";
                        this.$set(this.testResults, provider.id, { success: false, message: msg });
                        if (!silent) {
                            this.testModalData = { success: false, name: provider.name, model: provider.model, message: msg };
                            this.showTestModal = true;
                            this.$toast.error("Test gagal: " + msg);
                        }
                        return { success: false, message: msg };
                    }

                    // 2. Call test-key endpoint
                    // Backend field benar = `api_base_url` (bukan `base_url`), biar backend pakai
                    // OpenAI-compatible client dengan base URL sesuai provider (sumopod, dll).
                    const testRes = await this.$store.dispatch("chatgpt_test_key", {
                        api_key: apiKey,
                        models: provider.model,
                        api_base_url: provider.base_url,
                    });
                    const successMsg = (testRes.data && testRes.data.message) || "API Key valid dan model dapat diakses.";
                    this.$set(this.testResults, provider.id, { success: true, message: successMsg });
                    if (!silent) {
                        this.testModalData = { success: true, name: provider.name, model: provider.model, message: successMsg };
                        this.showTestModal = true;
                        this.$toast.success(provider.name + ": OK");
                    }
                    return { success: true, message: successMsg };
                } catch (err) {
                    const msg = (err.response && err.response.data && err.response.data.message)
                        ? err.response.data.message
                        : (err.message || "Unknown error");
                    this.$set(this.testResults, provider.id, { success: false, message: msg });
                    if (!silent) {
                        this.testModalData = { success: false, name: provider.name, model: provider.model, message: msg };
                        this.showTestModal = true;
                        this.$toast.error(provider.name + ": Gagal");
                    }
                    return { success: false, message: msg };
                } finally {
                    this.$set(this.testingProviders, provider.id, false);
                }
            },
            async testProvider(provider) {
                await this.runSingleTest(provider, { silent: false });
            },
            async testAllProviders() {
                if (this.isTestingAll) return;
                this.isTestingAll = true;
                let okCount = 0;
                let failCount = 0;
                try {
                    // Test sequentially (hindari overload provider API)
                    for (const p of this.providers) {
                        const result = await this.runSingleTest(p, { silent: true });
                        if (result.success) okCount++; else failCount++;
                    }
                    if (failCount === 0) {
                        this.$toast.success(`Semua provider OK (${okCount}/${this.providers.length}).`);
                    } else {
                        this.$toast.error(`${failCount} provider gagal, ${okCount} OK. Cek icon di kolom Nama.`);
                    }
                } finally {
                    this.isTestingAll = false;
                }
            },
            async performDelete() {
                if (!this.deleteTargetId) return;

                try {
                    this.isDeleting = true;
                    await this.$store.dispatch("chatgpt_delete_provider", {
                        id: this.deleteTargetId
                    });
                    this.$toast.success("Provider telah dihapus.");
                    this.getProviders();
                    this.closeDeleteModal();
                } catch (error) {
                    this.$toast.error("Gagal menghapus provider.");
                } finally {
                    this.isDeleting = false;
                }
            },
        },
    };
</script>
<style scoped>
.radius-xl {
    border-radius: 1rem !important;
}
.radius-md {
    border-radius: 0.5rem !important;
}
.bg-primary-light {
    background-color: #eef2ff !important;
}
.bg-soft-danger {
    background-color: #fff5f5 !important;
}
.bg-soft-success {
    background-color: #e6fffa !important;
}
.badge-soft-success {
    background-color: #e6fffa;
    color: #2c7a7b;
}
.badge-soft-danger {
    background-color: #fff5f5;
    color: #c53030;
}
.badge-soft-primary {
    background-color: #eef2ff;
    color: #4f46e5;
}
.badge-soft-light {
    background-color: #f8fafc;
    color: #64748b;
}
.avatar-sm {
    width: 32px;
    height: 32px;
    font-size: 14px;
}
.icon-shape {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: middle;
}
.btn-icon {
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
</style>
